export default "/images/vendor/flag-icons/flags/4x3/gb-sct.svg?5edc6d75a73111158da1213a861644d8";